import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export class InitialCheckBoxClickHandler {
  toggleSelected(node: OurNode) {
    const logger = getLogger();
    const t0 = performance.now();
    logger.debug("t0 - start of action", t0);

    const initialStructureNodeset = getInitialStructureNodeset();

    const newSelectedIds = new Set(initialStructureNodeset.selectedNodeIds);

    if (node.selected) {
      node.deselectYourselfAndAllChildren((n) => {
        newSelectedIds.delete(n.id);
      });
    } else {
      node.selectYourselfAndAllChildren((n) => {
        newSelectedIds.add(n.id);
      });
    }

    initialStructureNodeset.setSelectedNodeIds(newSelectedIds);

    const rootNode = node.returnRootNodeFromOurNode();

    initialStructureNodeset.setRootNode(rootNode);
    const flatMap = rootNode.createMapFromOurNodeTree();
    initialStructureNodeset.setFlatMap(flatMap);

    const t1 = performance.now();
    logger.debug("t1 - end of action", t1);
    logger.debug(
      `Action to to select node with new structure took ${
        t1 - t0
      } milliseconds.`,
    );
  }
}
